<template>
  <div>
    <div class="message_board">
      <el-container>
        <el-main>
          <el-link type="info">2023-05-20 16:21:07</el-link><br>
          Admin: 今天一共有23个客户需要联系跟进, 目前已经联系了17个, 剩余5个, 请大家加快进度。
          <br><br>
          <el-link type="info">2023-05-20 16:36:25</el-link><br>
          Kaka: 收到。
        </el-main>
      </el-container>
    </div>
  </div>
</template>

<script>
import Nav from '../Global/Nav.vue'
export default {
  name: 'MessageBoard',
  components: {
    Nav
  },
  data() {
    return {
    }
  },
  mounted() {
  },
  methods: {
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/Modules/MessageBoard.vue